import { ActivityIndicator } from "react-native";

import { LoaderProps } from "./Loader.types";
import { useTheme } from "@grassrootly/rn-core/src/structure";
export const Loader = ({ isLoading = true, color, size }: LoaderProps) => {
  const { theme } = useTheme();
  return <ActivityIndicator animating={isLoading} color={color || theme.colors.primary.main} size={size} />;
};
